module.exports = __webpack_public_path__ + "static/portfolio_tlba4-fs8-214694af31399450f6d7624550f147dd.png";